import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { getPortalConfigSelector, PortalConfiguration } from "../../ducks/portalConfig";

export const useLoginFormSettings = () => {
  const { t } = useTranslation();
  const config = useSelector(getPortalConfigSelector);
  const { loginForm, withPortal, allowRegistration, allowSNS, allowRecovery, showTermsOfService, disabledComponents } =
    (config?.settings as PortalConfiguration["settings"]) || {};
  const { title, login, password, loginWith, terms, button, remember, signUp } = loginForm || {};

  return {
    title: title || t("loginTitle"),
    login: login || t("login"),
    password: password || t("password"),
    button: button || t("signIn"),
    remember: remember || t("forgotLoginPassword"),
    signUp: signUp || t("signUp"),
    loginWith: loginWith || t("loginWith"),
    terms,
    withPortal,
    allowRegistration,
    allowSNS,
    allowRecovery,
    showTermsOfService,
    disabledComponents,
  };
};
